import { render, staticRenderFns } from "./freightList.vue?vue&type=template&id=3cc67c00&scoped=true"
import script from "./freightList.vue?vue&type=script&lang=js"
export * from "./freightList.vue?vue&type=script&lang=js"
import style0 from "./freightList.vue?vue&type=style&index=0&id=3cc67c00&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc67c00",
  null
  
)

export default component.exports